import { Form, FormInstance } from "antd";
import React from "react";
import { edCompField } from "../ParamsEditorInfo2";
import {
  Accept,
  MaxCount,
  MaxSize,
  MultipleChoiceIteratorDepend,
} from "./common";

type Props = {
  form: FormInstance;
};
export const UploaderEdProps: React.FC<Props> = ({ form }) => {
  const multiple = Form.useWatch(edCompField("multiple"));
  return (
    <>
      <MultipleChoiceIteratorDepend form={form} />
      {multiple && <MaxCount />}
      <MaxSize />
      <Accept />
    </>
  );
};
